import {
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Typography,
  message,
  notification,
} from "antd";
import React, {useEffect, useState} from "react";
import "./ExpandInfo.scss";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {RECEIVE_ACTION_TYPE} from "types/enums/receive-action-type";
import {sharedDirectory} from "api";
import Notification from "components/common/notification/notification";

const ExpandInfo = props => {
  const {form, expandMoreInfo, setExpandMoreInfo} = props;
  const [quocTich, setQuocTich] = useState<any>(null);
  const [danToc, setDanToc] = useState<any>(null);
  const [expandStyle, setExpandStyle] = useState<any>({
    display: "none",
  });
  const dispatch = useAppDispatch();
  const [isOpenDate, setIsOpenDate] = useState<boolean>(false);
  useEffect(() => {}, [isOpenDate]);

  const transformCode = (v, namePath) => {
    form.setFieldValue(namePath, String(v).toUpperCase());
  };
  const hideMoreInfo = () => {
    setExpandMoreInfo(!expandMoreInfo);
  };
  const toOptions = dts => {
    // console.log(dts);
    return dts.map(dt => {
      return {
        value: dt.id,
        label: dt.name,
      };
    });
  };
  const toNationOptions = ns => {
    return ns.map(dt => {
      return {
        value: dt.id,
        label: dt.nameVN,
      };
    });
  };
  const fetchNation = async () => {
    try {
      let response = await sharedDirectory.getListNation();
      setQuocTich(response.data.data);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục quốc tịch");
    }
  };
  const fetchDanToc = async () => {
    try {
      let response = await sharedDirectory.getListDanToc();
      setDanToc(response.data.data);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục dân tộc");
    }
  };
  useEffect(() => {
    fetchNation();
    fetchDanToc();
  }, []);
  useEffect(() => {}, [danToc, quocTich]);
  return (
    <Row
      className="expand-info"
      style={expandMoreInfo ? {} : {display: "none"}}
    >
      <Row onClick={hideMoreInfo}>
        <Typography.Text strong>Thông tin mở rộng</Typography.Text>
        <Typography.Text className="describe-text">
          (Nhấn để rút gọn)
        </Typography.Text>
      </Row>
      <Divider type="horizontal" />
      <Row>
        <Form labelAlign="left" form={form}>
          <Row gutter={[8, 8]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Quốc tịch</Typography.Text>}
                name="quocTich"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className="data-select-field"
                  options={quocTich ? toNationOptions(quocTich) : []}
                  allowClear
                  disabled={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Tôn giáo</Typography.Text>}
                name="tonGiao"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input className="data-input-field" disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Dân tộc</Typography.Text>}
                name="danToc"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Select
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  className="data-select-field"
                  options={danToc ? toOptions(danToc) : []}
                  disabled={true}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Nghề nghiệp</Typography.Text>}
                name="ngheNghiep"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input className="data-select-field" disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Nơi làm việc</Typography.Text>}
                name="noiLamViec"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input className="data-input-field" disabled={true} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Số CMND</Typography.Text>}
                name="soCmnd"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input
                  className="data-input-field"
                  disabled={true}
                  onChange={e => transformCode(e.target.value, "soCmnd")}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Ngày cấp</Typography.Text>}
                name="ngayCap"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <DatePicker
                  className="data-picker-field"
                  disabled={true}
                  format={isOpenDate ? "DDMMYYYY" : "DD/MM/YYYY"}
                  placeholder=""
                  onOpenChange={() => setIsOpenDate(!isOpenDate)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item
                label={<Typography.Text ellipsis>Nơi cấp</Typography.Text>}
                name="noiCap"
                labelAlign="left"
                labelCol={{span: 8}}
                wrapperCol={{span: 16}}
              >
                <Input className="data-input-field" disabled={true} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
    </Row>
  );
};

export default ExpandInfo;
